import { createSlice } from "@reduxjs/toolkit";


const KEY_LOCAL = "products_local"
const initState = localStorage[KEY_LOCAL] ? JSON.parse(localStorage[KEY_LOCAL]) :
    {
        products_ar: []
    }

const productsSlice = createSlice({
    name: "products",
    initialState: initState,
    reducers: {
        addNewItem: (state, action) => {
            state.products_ar.unshift(action.payload.productItem)
            saveToLocal(state)
        },
        resetAllItems: (state, action) => {
            state.products_ar = [];
            saveToLocal(state)

        },
        delSingleItem: (state, action) => {
            state.products_ar = state.products_ar.filter(
                (item) => item.id != action.payload.delId
            );
            saveToLocal(state)
        }
    }
})

const saveToLocal = (state) => {
    localStorage.setItem(KEY_LOCAL, JSON.stringify(state))
}
export const { addNewItem, resetAllItems, delSingleItem } = productsSlice.actions;
export default productsSlice.reducer;